import styled from 'styled-components';
import colors from '../../utils/colors';
import { outlines } from '../../utils/theme';
import typography from '../../utils/typography';
const { display6 } = typography;
const { skyDarker, blend, meld } = colors;
export const StyledTextLink = styled.a.withConfig({
    shouldForwardProp: (prop) => !['iconPosition'].includes(prop),
})(({ iconPosition }) => [
    display6,
    {
        boxSizing: 'border-box',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 'max-content',
        padding: '0.125rem 0',
        gap: '0.25rem',
        cursor: 'pointer',
        backgroundColor: 'transparent',
        textDecoration: 'none',
        color: skyDarker,
        border: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
        '&:active': {
            backgroundColor: blend,
        },
        '&:focus-visible': {
            borderRadius: '5px',
            outlineOffset: '1px',
            outline: outlines.focus,
        },
        '&[disabled]': {
            color: meld,
            cursor: 'not-allowed',
            '&:hover': { textDecoration: 'none' },
            '&:active': { backgroundColor: 'transparent' },
        },
        svg: {
            height: '1rem',
            width: '1rem',
            order: iconPosition === 'right' ? '1' : '0',
        },
    },
]);
